import { AxiosRequestConfig } from 'axios';
import axios from 'src/axios';
import { validateFileUpload } from './validateFileUpload/fileValidation';

export const uploadToPresignedUrl = async ({
  url,
  file,
  tags,
  controller,
  onUploadProgress = () => {},
  filename,
  mimeType,
}: {
  url: string;
  file: Blob | File;
  tags?: Record<string, string>;
  controller?: AbortController;
  onUploadProgress?: AxiosRequestConfig['onUploadProgress'];
  filename?: string;
  mimeType?: string;
}) => {
  const tagsQueryString = new URLSearchParams(tags).toString();

  if (file instanceof Blob) {
    try {
      const fileToValidate =
        file instanceof File
          ? file
          : new File([file], filename || 'blob', {
              type: mimeType || file.type,
            });
      validateFileUpload({ file: fileToValidate });
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : 'File validation failed. Please check the file type and try again.',
      );
    }
  }

  return axios.put(url, file, {
    headers: {
      ...(tags && {
        'x-amz-tagging': tagsQueryString,
      }),
    },
    signal: controller?.signal,
    timeout: 0,
    onUploadProgress,
  });
};
